import React from "react";

const Pro = () => {
    return (
        <div id="app-pro" className={"guide-paragraph"}>
            <h2>8. Application PRO version</h2>

            <div id="app-pro-why" className={"guide-paragraph-low"}>
                <h3>8.1 Why are some of the application’s functions paid?</h3>
                <p>
                    This application is not developed by a team or a company – it is being developed by one
                    developer during his own free time. The development of the application takes a lot of
                    effort and time including some financial investments. Therefore, to replenish my
                    strength and support the application, you can buy coffee or any delicious treat in the
                    application. I will be very grateful for any purchase and all the additional functions
                    of the application will open to you.
                </p>
            </div>

            <div id={"app-pro-features"} className={"guide-paragraph-low"}>
                <h3>8.2 List of PRO Features</h3>
                <p>
                    <ul>
                        <li>Synchronization of data with the cloud, linking to a google account</li>
                        <li>Data backup</li>
                        <li>Ability to view, edit, and delete activities</li>
                        <li>Create an unlimited number of categories</li>
                        <li>Various color styles</li>
                        <li>Dark theme</li>
                        <li>Keep screen on</li>
                        <li>Daily reminders</li>
                        <li>More background sounds</li>
                    </ul>
                </p>
            </div>
        </div>
    )
}

export default Pro